<template>
  <div class="container">
    <img class="gaokaoBac" src="../assets/gaokao_bac.png"/>
    <div class="smallBall"></div>
    <!-- <div class="upBall" v-if="switchBall" v-else></div> -->
    <img class="starGif" src="../assets/star.gif"/>
    <img class="writeBall" src="../assets/pink_ball.png"/>
    <img class="lineStar" src="../assets/line_star.png"/>
    <div class="mainContainer">
      <img src="../assets/waveline.png"/>
      <div class="maintext" v-for="(item, index) in textOne" :key="index">{{ item }}</div>
    </div>
    <div class="optContainer">
      <div class="mainTitle">积极影响</div>
      <div class="radioContainer">
        <div class="radioItem" v-for="(item, index) in options" :key="index">
          <input name="options" type="radio" :value="index+1" @click="clickRadio"/>
          <span :style="{backgroundImage:'url(' + item + ')'}"></span>
        </div>
      </div>
    </div>
    <div class="optContainer">
      <div class="mainTitle">或消极影响</div>
      <div class="radioContainer redioNeg">
        <div class="radioItem" v-for="(item, index) in optionsNeg" :key="index">
          <input name="options" type="radio" :value="-index-1" @click="clickRadio"/>
          <span :style="{backgroundImage:'url(' + item + ')'}"></span>
        </div>
      </div>
    </div>
    <button class="confirmBtn" @click="confirm"></button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      textOne: [
        '如果',
        '高考是你此生不得不做的事',
        '那它对你有多大的影响',
        '是积极还是消极的？'
      ],
      options: [
        require('../assets/select_num/num1.png'),
        require('../assets/select_num/num2.png'),
        require('../assets/select_num/num3.png'),
        require('../assets/select_num/num4.png'),
        require('../assets/select_num/num5.png'),
      ],
      optionsNeg: [
        require('../assets/select_num/num-1.png'),
        require('../assets/select_num/num-2.png'),
        require('../assets/select_num/num-3.png'),
        require('../assets/select_num/num-4.png'),
        require('../assets/select_num/num-5.png'),
      ],
      value: '',
      switchBall: true
    }
  },
  methods: {
    clickRadio (e) {
      this.value = e.target.value;
    },
    confirm () {
      if(this.value !== ''){
        this.switchBall = false
        let that = this;
        let results = [];
        results[3] = {
          text: '高考',
          score: that.value
        }
        this.$store.commit('setResults', results);
        //setTimeout(()=>{
          this.$router.replace({path:'/gaokaopre'})
        //}, 2000)
      }
    }
  }
}
</script>
<style scoped>
.container{
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background: #bbdde7;
  padding-top: 2rem;
  box-sizing: border-box;
  letter-spacing: 0.03rem;
  position: relative;
  z-index: -2;
  overflow: hidden;
}
.mainContainer{
  width: 100%;
  margin: 0 0 0.6rem;
  position: relative;
}
.mainContainer img{
  position: absolute;
  width: 0.8rem;
  height: 0.08rem;
  top: 1rem;
  left: 50%;
  transform: translateX(-2.7rem);
}
.maintext{
  font-size: 0.33rem;
  line-height: 0.55rem;
  height: 0.55rem;
  width: 5.2rem;
  margin: 0 auto;
}
.mainTitle{
  font-size: 0.33rem;
  line-height: 0.55rem;
  text-align: left;
  width: 5.2rem;
  margin: 0 auto;
}
.mainTitle::after{
  content: '/';
  font-size: 0.16rem;
}
.optContainer{
  width: 5.2rem;
  font-size: 0.33rem;
  margin: 0.6rem auto;
}
.radioContainer{
  margin-top: 0.35rem;
}
.radioItem{
  display: inline-block;
  width: 0.62rem;
  height: 0.62rem;
  text-align: left;
  overflow: hidden;
  position: relative;
  margin-right: 0.42rem;
}
input[type="radio"]{
  appearance: none;
  width: 0.62rem;
  height: 0.62rem;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  outline: none;
  border: none;
}
input[type="radio"] + span{
  border-radius: 50%;
  background-color: #faeae7;
  display: block;
  width: 0.62rem;
  height: 0.62rem;
  line-height: 0.62rem;
  text-align: center;
  background-size: 100% 100%;
}
input[type="radio"]:checked{
  background-color: transparent;
}
input[type="radio"]:checked + span{
  background: url(../assets/smile.png) no-repeat !important;
  background-size: 100% 100%  !important;
  color: transparent  !important;
}
.redioNeg input[type="radio"]:checked + span{
  background: url(../assets/sad.png) no-repeat  !important;
  background-size: 100% 100%  !important;
  color: transparent  !important;
}
.optText::after{
  content: '/';
  font-size: 0.16rem;
}
.confirmBtn{
  appearance: none;
  width: 3.22rem;
  height: 0.91rem;
  background: url(../assets/confirm_btn.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin: 1rem auto 0;
  padding: 0;
  outline: none;
  border: none;
  position: relative;
}
.confirmBtn::after{
  content: '';
  width: 0.72rem;
  height: 0.25rem;
  position: absolute;
  top: 0.15rem;
  left: -0.36rem;
  background: url(../assets/confirm_btn_left.png) no-repeat;
  background-size: 100% 100%;
}
.smallBall{
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background-color: #aed1b8;
  position: absolute;
  bottom: 0.83rem;
  right: 0.3rem;
  border: 0.02rem solid #504e4a;
  /* animation: scollToRight 4s 0.5s; */
}
@keyframes scollToRight{
  0% {left: 0;bottom: 6.5rem;background-color: #d7594c;}
  10% {left: 0.9rem;bottom: 6.5rem;background-color: #d7594c;}
  60% {left: 0.9rem;bottom: 0.83rem;background-color: #d7594c;}
  100% {left: 6.9rem;bottom: 0.83rem; background-color: #d7594c;}
}
.upBall{
  width: 0.3rem;
  height: 0.3rem;
  border-radius: 50%;
  background-color: #d7594c;
  position: absolute;
  bottom: 8rem;
  right: 0.3rem;
  border: 0.02rem solid #504e4a;
  animation: scollToTop 1s;
}
@keyframes scollToTop{
  0% {right: 0.3rem;bottom: 0.83rem;}
  100% {right: 0.3rem;bottom: 8rem;}
}
.starGif{
  width: 11.25rem;
  height: 17.89rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.writeBall{
  width: 0.38rem;
  height: 0.38rem;
  border-radius: 50%;
  position: absolute;
  right: 6.1rem;
  bottom: 0.25rem;
  animation: beBigger 0.5s 2s;
  animation-fill-mode:forwards;
  transform: scale(0);
}
@keyframes beBigger {
  0% {transform: scale(0);}
  100% {transform: scale(1);}
}
.lineStar{
  width: 0.27rem;
  height: 0.23rem;
  position: absolute;
  top: 1.15rem;
  left: 0.7rem;
}
.gaokaoBac{
  width: 7.11;
  height: 9.05rem;
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>

